import { IAiBlackboxProps } from '../type'
import MwbBonusTracker from './MwbBonusTracker'

export default function getExpoContent(
  contentPartName: string,
): React.FC<IAiBlackboxProps> | null {
  switch (contentPartName) {
    case 'expoMwbBonusTracker':
      return MwbBonusTracker
    default:
      return null
  }
}
